import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntitlements } from '@/entitlements/useEntitlements';
import { usePricingModal } from '@/context/PricingModalContext';

interface LoginSubscribeFooterModalProps {
  visible: boolean;
  onLoginOrCreateAccount: () => void;
  onSubscribe: () => void;
  context?: 'library' | 'generic';
}

export default function LoginSubscribeFooterModal({
  visible,
  onLoginOrCreateAccount,
  onSubscribe,
  context = 'library'
}: LoginSubscribeFooterModalProps) {
  const navigate = useNavigate();
  const { isAuthenticated, isSubscribed, hasValidAccess, subscriptionTier } = useEntitlements();
  const { openPricingModal } = usePricingModal();
  
  // Don't show modal if user has valid access (subscribed OR on free trial)
  if (!visible || hasValidAccess) {
    return null;
  }

  const handleButtonClick = () => {
    // TODO: Analytics placeholder: onPrimaryClick
    if (isAuthenticated && !isSubscribed) {
      openPricingModal();
    } else {
      navigate('/auth/signup');
    }
  };

  const getButtonText = () => {
    if (isAuthenticated && !isSubscribed) {
      return "Subscribe Now to Unlock Full Access";
    }
    return "Create account";
  };

  const getModalContent = () => {
    if (isAuthenticated && !isSubscribed) {
      return {
        title: "Need more inspiration?",
        subtitle: "We don't blame you. These are just a few of the 50,000+ ads available"
      };
    }
    return {
      title: "Need more inspiration?",
      subtitle: "We don't blame you. These are just a few of the 50,000+ ads available"
    };
  };

  const modalContent = getModalContent();

  return (
    <>
      {/* Blur fade overlay - dark gradient */}
      <div 
        className="fixed bottom-[120px] left-0 right-0 z-40 h-40 pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, transparent 0%, rgba(19, 23, 28, 0.1) 25%, rgba(19, 23, 28, 0.4) 50%, rgba(19, 23, 28, 0.7) 75%, rgba(19, 23, 28, 0.95) 100%)',
          backdropFilter: 'blur(2px)',
        }}
      />
      
      <div 
        className="fixed bottom-0 left-0 right-0 z-50 px-6 py-6"
        style={{
          background: 'linear-gradient(to bottom, rgba(19, 23, 28, 0.95) 0%, rgba(19, 23, 28, 0.98) 50%, rgb(19, 23, 28) 100%)',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        }}
        role="dialog"
        aria-label="Subscribe or login to continue"
      >
      <div className="max-w-md mx-auto flex flex-col items-center text-center gap-4">
        <div>
          <h3 className="font-semibold text-xl mb-2 text-white">
            {modalContent.title}
          </h3>
          {modalContent.subtitle && (
            <p className="text-sm text-white/60">
              Get access to{' '}
              <span 
                className="font-semibold"
                style={{
                  backdropFilter: 'blur(4px)',
                  background: 'linear-gradient(to bottom, #70BAFF, #258BFF)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                500+
              </span>
              {' '}high performing ads from{' '}
              <span 
                className="font-semibold"
                style={{
                  backdropFilter: 'blur(4px)',
                  background: 'linear-gradient(to bottom, #70BAFF, #258BFF)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                50
              </span>
              {' '}viral DTC brands.
            </p>
          )}
        </div>
        
        <button
          onClick={handleButtonClick}
          className="w-full px-8 py-4 text-lg font-medium text-white rounded-[14px] shadow-[0_4px_14px_0_rgba(37,139,255,0.39)] hover:opacity-90 active:scale-[0.98] transition-all"
          style={{
            background: 'linear-gradient(180deg, #70BAFF 0%, #258BFF 100%)',
          }}
        >
          {getButtonText()}
        </button>
      </div>
      </div>
    </>
  );
}